module.exports = "<input\r\n    [type]=\"inputType\"\r\n    class=\"text-entry-input\"\r\n    [maxlength]=\"maxChar\"\r\n    [formControl]=\"textEntryControl\"\r\n    [style.width]=\"width + 'em'\"\r\n    [placeholder]=\"placeHolderText\"\r\n    spellcheck=\"false\"\r\n    />"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/text-entry-interaction/text-entry-interaction.html
// module id = wadJ
// module chunks = 1